const user = {
  id: 0,
  email: "",
  password: "",
  countryCode: null,
  phoneNumber: null,
  role: "",
  firstName: null,
  lastName: null,
  emailVerified: null,
  homeStore: null,
  homeOrg: null,
  isClientUser: null,
  zipCode: null,
  IsSendNewLetter: false,
  isDeleted: null,
  createdDttm: 0,
  updatedDttm: 0,
};

export default user;
